import styled, { css } from 'styled-components';

import Image from 'Elements/Image';
import { InnerContent } from 'Modules/Banner/Information/Information.styled';

export const List = styled.ul`
    ${({ theme }) => css`
        display: flex;
        flex-wrap: wrap;
        list-style: none;
        padding: 0.5rem;

        @media ${theme.breakpoints.small.media} {
            margin-top: -1.5rem;

            ${InnerContent} & {
                margin-top: 0;
            }
        }
    `}
`;

export const Item = styled.li`
    display: flex;
    align-items: center;
`;

export const ImageIcon = styled(Image)`
    width: 2rem;
    height: 2rem;
`;

export const StyledIcon = styled.svg<{ $iconColour?: string }>`
    ${({ $iconColour }) => css`
        width: 2rem;
        height: 2rem;

        ${$iconColour &&
        css`
            color: ${$iconColour};
        `}
    `}
`;

export const Text = styled.span`
    padding-left: 0.75rem;
    font-weight: 700;
`;

export const Container = styled.div`
    ${({ theme }) => css`
        /*https://alistapart.com/article/axiomatic-css-and-lobotomized-owls/*/
        ${List} > * + * {
            margin: 1.5rem 1.5rem 0 0;
        }

        @media ${theme.breakpoints.small.media} {
            ${List} > * {
                margin: 1.5rem 1.5rem 0 0;
            }
        }
    `}
`;
